import React from 'react';
import { css, cx } from 'styled-system/css';
import { cover } from 'styled-system/recipes';

interface CoverPlateProps {
  /** Short word on the plate ("SSR / RSC", "HTTP/3") */
  glyph: string;
  /** Which of the four plates (colors come from the design) */
  plate: number;
  className?: string;
  glyphClassName?: string;
}

const glyphStyle = css({
  position: 'relative',
  zIndex: '1',
  textStyle: 'glyph',
  _nebula: { textShadow: '0 2px 30px rgba(0, 0, 0, .3)' },
});

/**
 * A generated article cover (no stock photos): a picture-book sun over a hill in Storybook,
 * a drifting aurora in Nebula.
 */
export function CoverPlate({ glyph, plate, className, glyphClassName }: CoverPlateProps) {
  const n = String((Math.abs(plate) % 4) + 1) as '1' | '2' | '3' | '4';
  return (
    <div className={cx(cover({ plate: n }), className)} aria-hidden>
      <span className={cx(glyphStyle, glyphClassName)}>{glyph}</span>
    </div>
  );
}
